import { KeyboardConfigs } from './types'

const numbersRow = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0']

const qwertyConfig = [
  numbersRow,
  ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
  ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', '-'],
  ['Z', 'X', 'C', 'V', 'B', 'N', 'M', ',', '.', '?'],
]

// Layout of different sizes. Possibly we'll need it...

// const abcdef7x4Config = [
//   ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
//   ['H', 'I', 'J', 'K', 'L', 'M', 'N'],
//   ['O', 'P', 'Q', 'R', 'S', 'T', 'U'],
//   ['V', 'W', 'X', 'Y', 'Z', ',', '.'],
// ]

// const abcdef6x5Config = [
//   ['A', 'B', 'C', 'D', 'E', 'F'],
//   ['G', 'H', 'I', 'J', 'K', 'L'],
//   ['M', 'N', 'O', 'P', 'Q', 'R'],
//   ['S', 'T', 'U', 'V', 'W', 'X'],
//   ['Y', 'Z'],
// ]

const abcdefAltConfig = [
  numbersRow,
  ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'],
  ['K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T'],
  ['U', 'V', 'W', 'X', 'Y', 'Z', ',', '.', '?', '-'],
]

export const keyboardConfigs: KeyboardConfigs = {
  qwerty: qwertyConfig,
  abcdef: abcdefAltConfig,
}

export const ROW_COUNT = 4
export const COLUMNS_COUNT = 10
